import { AOFProjectItemModel } from '../../api/models';
import { FieldActionOnValuesFunction } from '../types';
import { anzsrcDivisionValues, AnzsrcCodeOptions, anzsrcGroupValues } from '../anzsrcList';
import { filter, concat, map } from 'lodash';
import { SelectInputOptions } from '../../components/input/selectInput/types';

export const anzsrcDivisionOptions = (_values: Partial<AOFProjectItemModel>) => anzsrcDivisionValues;

export const anzsrcGroupOptions = (values: Partial<AOFProjectItemModel>) => {
    const fullArray: AnzsrcCodeOptions[] = anzsrcGroupValues;
    const categoryCode = values.anzsrcDivision;
    const blankSelectOption: SelectInputOptions = { value: '', label: '' };
    const selectedValues: SelectInputOptions[] = map(filter(fullArray, a => a.divisionKey === categoryCode), v => {
        return { value: v.groupKey, label: v.groupLabel };
    });
    return concat([blankSelectOption], selectedValues);
};

const projects: FieldActionOnValuesFunction<AOFProjectItemModel> = {
    anzsrcDivision: anzsrcDivisionOptions,
    anzsrcGroup: anzsrcGroupOptions,
};

export default projects;
